<template lang="pug">
  span.span(:style="{fontSize, fontWeight}" v-html="text")
</template>
<script>
export default {
  name: 'Span',
  props: {
    text: {
      type: String,
      default: ''
    },
    fontSize: {
      type: String,
      default: ''
    },
    fontWeight: {
      type: String,
      default: ''
    }
  }
}
</script>
